<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerpt0101" class="chapter" epub:type="part" id="pt01" role="doc-part">
<header id="headerpt0101">
<h1 class="pn"><span aria-label="26" class="page" id="p26" role="doc-pagebreak"></span><span aria-label="27" class="page" id="p27" role="doc-pagebreak"></span><a class="xref" href="#/wsumidejewski0007#rpt01">I</a></h1>
<hr class="sec-break"/>
<p class="sec">✴♦✴♦✴</p>
<h1 class="pt"><a class="xref" href="#/wsumidejewski0007#rpt02">Leia/Carrie</a></h1>
</header>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-midejewski-0011.vue?71394e01